import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  booleanAttribute,
  Component,
  ElementRef,
  input,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'app-modal-container',
  styleUrls: ['./modal-container.css'],
  template: `
    <section
      #modal
      [ngClass]="class()"
      class="w-screen h-dvh lg:rounded-lg lg:w-auto lg:h-auto flex flex-col lg:max-h-180">
      <section #header class="rounded-t-lg overflow-hidden shrink-0 ">
        <ng-content select="[header]" />
      </section>
      <section
        [ngClass]="scrollDisabled() ? 'overflow-hidden' : 'overflow-y-auto'"
        #content
        class="h-full md:min-w-80  no-scrollbar flex-1 overflow-x-hidden">
        <ng-content />
      </section>
      <section
        class="md:static fixed bottom-0 w-full xl:rounded-b-[20px] overflow-hidden z-999 shrink-0 bg-white">
        <ng-content select="[footer]" />
      </section>
    </section>
  `,
  imports: [CommonModule],
})
export class ModalContainer implements AfterViewInit {
  modalRef = viewChild<ElementRef<HTMLElement>>('modal');
  contentRef = viewChild<ElementRef<HTMLElement>>('content');
  headerRef = viewChild<ElementRef<HTMLElement>>('header');
  footerRef = viewChild<ElementRef<HTMLElement>>('footer');

  class = input<string>('bg-white');
  invisibleWhitespace = input<boolean, string>(false, {
    transform: booleanAttribute,
  });
  scrollDisabled = input<boolean, string>(false, {
    transform: booleanAttribute,
  });

  ngAfterViewInit() {
    this.modalRef()?.nativeElement.animate(
      [
        { opacity: 0, transform: 'translateY(10px)' },
        { opacity: 1, transform: 'translateY(0)' },
      ],
      {
        duration: 200,
        easing: 'ease-in-out',
      }
    );

    const content = this.contentRef()?.nativeElement;
    const header = this.headerRef()?.nativeElement;
    const footer = this.footerRef()?.nativeElement;

    if (content) {
      const isMobile = window.innerWidth < 768;
      if (!isMobile) {
        content.style.paddingBottom = '0px';
        return;
      }

      const headerHeight = header?.offsetHeight || 0;
      const footerHeight = footer?.offsetHeight || 0;

      if (!this.invisibleWhitespace()) {
        content.style.paddingBottom = `${headerHeight + footerHeight}px`;
      }
    }
  }
}
